import React from 'react'
import "./deleteItemPartModal.css"

export const DeleteItemPartModal = ({ onClose, PNName, Quantity, deletePN }) => {
    const handleDelete = () => {
        deletePN()
        onClose()
    }
    return (
        <section className='delete-PN-cont'>
            <h3>Are you sure you want to <br /> delete this PN?</h3>
            <div className="delete-PN-pCont">
                <p>PN: <span>{PNName}</span></p>
                <p>QTY: <span>{Quantity}</span></p>
            </div>
            <div className='delete-PN-btnCont'>
                <button onClick={handleDelete}>Ok</button>
                <button onClick={onClose}>Cancel</button>
            </div>
        </section>)
}
